import React from 'react';
import { Link } from 'react-router-dom';
import he from 'he';

const formatPubDate = (dateString) => {
  if (!dateString) return '';

  const match = dateString.match(
    /^([A-Za-z]{3}) (\d{1,2}), (\d{4}) (\d{1,2}):(\d{2})(AM|PM)$/i
  );

  if (!match) return dateString;

  const [, month, day, year, hour, minute, ampm] = match;

  const monthMap = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11
  };

  const date = new Date(
    Number(year),
    monthMap[month],
    Number(day),
    Number(hour) % 12 + (ampm.toUpperCase() === 'PM' ? 12 : 0),
    Number(minute)
  );

  const weekday = date.toLocaleDateString('en-US', {
    weekday: 'short'
  });

  return `${weekday} ${month} ${day}, ${year} ${hour}:${minute}${ampm.toUpperCase()}`;
};

const NewsCardItem = ({ item, index, pn }) => {

  const urlLink = item?.url_link;

  const contentPath = urlLink?.includes('content/')
    ? urlLink.substring(urlLink.indexOf('content/') + 8)
    : null;

  const newsUrl = contentPath
    ? `/content/${contentPath}`
    : '/';

  return (
    <div
      className="political-news-card card home-card-grid-item"
      style={{ maxWidth: "100%" }}
    >
      <Link
        to={newsUrl}
        style={{ textDecoration: "none" }}
      >
        <div className="row g-0">

          <div className="col-sm-4 col-4">
            <img
              loading={
                index === 0 && pn === true
                  ? "auto"
                  : "lazy"
              }
              src={
                item?.stimg
                  ? item.stimg
                  : `${import.meta.env.BASE_URL}assets/images/error_img.webp`
              }
              alt="political-news-img"
              className="political-news-card-img"
            />
          </div>

          <div className="col-sm-8 col-8">
            <div className="political-news-card-body card-body">

              <h3 className="political-news-card-title">
                {item?.title
                  ? he.decode(item.title)
                  : 'No Title'}
              </h3>

              <p
                className="political-news-card-description"
                dangerouslySetInnerHTML={{
                  __html: item?.smalldesc
                    ? he.decode(item.smalldesc)
                    : ''
                }}
              />

              <p className="card-text">
                <small
                  className="text-body-secondary political-news-card-time notranslate"
                  translate="no"
                >
                  Published on: {formatPubDate(item?.pubdate)}
                </small>
              </p>

            </div>
          </div>

        </div>
      </Link>
    </div>
  );
};

export default NewsCardItem;